import axiosInstance from './AxiosConfig';

export const fetchEquiposByFederacion = async (idFederacion) => {
  try {
    const response = await axiosInstance.get(`/api/equipos?id_federacion=${idFederacion}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los equipos:', error);
    throw error;
  }
};

export const createTeam = async (formData) => {
  try {
      const response = await axiosInstance.post('/api/equipos', formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      });
      return response.data;
  } catch (error) {
      console.error('Error al crear el equipo:', error);
      throw error;
  }
};

export const deleteTeam = async (idTeam) => {
  try {
    const response = await axiosInstance.delete(`/api/equipos/${idTeam}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el equipo:', error);
    throw error;
  }
};

export const updateTeam = async (idTeam, data) => {
  try {
    const response = await axiosInstance.put(`/api/equipos/${idTeam}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error al modificar el equipo:', error);
    throw error;
  }
};